
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 18c0-1.819.737-3.563 2.05-4.849A7.074 7.074 0 017 11.143c1.857 0 3.637.722 4.95 2.008A6.787 6.787 0 0114 18h-1.75a5.09 5.09 0 00-1.538-3.636A5.306 5.306 0 007 12.857a5.306 5.306 0 00-3.712 1.507A5.09 5.09 0 001.75 18H0zm7-7.714c-2.9 0-5.25-2.302-5.25-5.143C1.75 2.3 4.1 0 7 0s5.25 2.301 5.25 5.143c0 2.841-2.35 5.143-5.25 5.143zM7 8.57c1.934 0 3.5-1.534 3.5-3.428S8.934 1.714 7 1.714 3.5 3.25 3.5 5.143 5.066 8.57 7 8.57z","fill":"#FAAD14"}})])
          )
        }
      }
    